import styled from 'styled-components';
import { panelTheme } from './PanelComerciales.theme';

export const PanelRoot = styled.div`
    background: ${panelTheme.colors.background};
    color: ${panelTheme.colors.text};
    min-height: 600px;
    padding: 16px 0 32px;
    border-radius: ${panelTheme.radius.md};
`;

export const PanelMain = styled.main`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Card = styled.section`
    background: ${panelTheme.colors.surface};
    border: 1px solid ${panelTheme.colors.border};
    border-radius: ${panelTheme.radius.lg};
    box-shadow: ${panelTheme.shadow.sm};
    overflow: hidden;
`;

export const CardBody = styled.div`
    padding: 16px 20px 20px;
    overflow-x: auto;
`;

export const CardHeader = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    border-bottom: 1px solid ${panelTheme.colors.border};
    background: linear-gradient(
        135deg,
        ${panelTheme.colors.surface} 0%,
        ${panelTheme.colors.surfaceMuted} 100%
    );

    h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: ${panelTheme.colors.text};
    }

    p {
        margin: 4px 0 0;
        font-size: 12px;
        color: ${panelTheme.colors.textMuted};
    }
`;

export const StatusPill = styled.span<{ $variant: 'success' | 'warning' | 'danger' | 'muted' }>`
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: ${panelTheme.radius.pill};
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    ${({ $variant }) => {
        switch ($variant) {
            case 'success':
                return `background: rgba(16, 185, 129, 0.12); color: #047857;`;
            case 'warning':
                return `background: rgba(245, 158, 11, 0.14); color: #B45309;`;
            case 'danger':
                return `background: rgba(239, 68, 68, 0.12); color: #B91C1C;`;
            default:
                return `background: rgba(107, 100, 133, 0.12); color: #4B4665;`;
        }
    }}
`;

export const SpecialtyBar = styled.div`
    display: flex;
    width: 160px;
    height: 8px;
    border-radius: ${panelTheme.radius.pill};
    overflow: hidden;
    background: ${panelTheme.colors.borderStrong};

    span {
        height: 100%;
    }
`;

export const TableScroll = styled.div`
    width: 100%;
    overflow-x: auto;
    border-radius: ${panelTheme.radius.md};

    table {
        width: 100%;
        border-collapse: collapse;
    }

    th, td {
        padding: 10px 12px;
        text-align: left;
        font-size: 13px;
        border-bottom: 1px solid ${panelTheme.colors.border};
    }

    th {
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.6px;
        color: ${panelTheme.colors.textMuted};
        background: ${panelTheme.colors.surfaceMuted};
        position: sticky;
        top: 0;
    }

    tbody tr:hover {
        background: ${panelTheme.colors.surfaceMuted};
    }
`;

export const ActionsRow = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
`;

export const FieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 12px;

    label {
        font-size: 12px;
        font-weight: 600;
        color: ${panelTheme.colors.textMuted};
    }

    .helper {
        font-size: 11px;
        color: ${panelTheme.colors.textMuted};
    }

    .error {
        font-size: 11px;
        color: ${panelTheme.colors.danger};
    }
`;
